import { useCallback, useState } from "react";
import { NOTES } from "./notes";

const KEYS = { "en-US": "dash-deck-notes-v1", "id-ID": "dash-deck-notes-id-v1" };

const load = (lang) => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEYS[lang]));
    return Array.isArray(saved) && saved.length === NOTES[lang].length ? saved : NOTES[lang];
  } catch {
    return NOTES[lang];
  }
};

export function useNotes(lang) {
  const [all, setAll] = useState(() => ({ "en-US": load("en-US"), "id-ID": load("id-ID") }));

  const save = useCallback(
    (i, note) => {
      setAll((prev) => {
        const next = prev[lang].map((n, k) => (k === i ? note : n));
        localStorage.setItem(KEYS[lang], JSON.stringify(next));
        return { ...prev, [lang]: next };
      });
    },
    [lang]
  );

  const resetOne = useCallback((i) => save(i, NOTES[lang][i]), [save, lang]);

  return { notes: all[lang], save, resetOne };
}
